import { Box, Image } from '@chakra-ui/react';
import _ from 'lodash';
import { FC } from 'react';

interface Props {
  authors: string[];
}

const CommentAuthorsPreview: FC<Props> = ({ authors }) => {
  const avatarSize = 30;
  const avatarOffset = 28;
  const maxAvatarSize = 3;
  const avatarsCount = Math.min(authors.length, maxAvatarSize);

  return (
    <Box
      pos="relative"
      w={`${avatarSize + (avatarsCount - 1) * avatarOffset}px`}
      h="30px"
    >
      {_.take(authors, maxAvatarSize).map((author, index) => (
        <Image
          key={index}
          border="1.5px solid #fff"
          borderRadius="50%"
          position="absolute"
          top="0"
          left={`${index * avatarOffset}px`}
          src={author}
          w={`${avatarSize}px`}
          h={`${avatarSize}px`}
        />
      ))}
    </Box>
  );
};

export default CommentAuthorsPreview;
